export default "__VITE_ASSET__DKts9sy3__"